import { Evidence } from "domain";

export const initState = {
    list: [],
    current: null,
    isLoading: false,
    hasFailed: false
};

export default function evidenceReducer(state = initState, action) {
    const { type, payload } = action;

    switch (type) {
        case 'LIST_EVIDENCE_PENDING': {
            return { ...state, isLoading: true, hasFailed: false };
        }

        case 'LIST_EVIDENCE_REJECTED': {
            return { ...state, isLoading: false, hasFailed: true };
        }

        case 'LIST_EVIDENCE_FULFILLED': {
            return {
                ...state,
                list: payload.map(item => new Evidence(item)),
                isLoading: false,
                hasFailed: false
            };
        }

        case 'GET_EVIDENCE_PENDING': {
            return { ...state, isLoading: true, hasFailed: false };
        }

        case 'GET_EVIDENCE_REJECTED': {
            return { ...state, isLoading: false, hasFailed: true };
        }

        case 'GET_EVIDENCE_FULFILLED': {
            return {
                ...state,
                current: new Evidence(payload),
                isLoading: false,
                hasFailed: false
            };
        }

        case 'SAVE_EVIDENCE_PENDING': {
            return { ...state, isLoading: true, hasFailed: false };
        }

        case 'SAVE_EVIDENCE_REJECTED': {
            return { ...state, isLoading: false, hasFailed: true };
        }

        case 'SAVE_EVIDENCE_FULFILLED': {
            return {
                ...state,
                current: new Evidence(payload),
                isLoading: false,
                hasFailed: false
            };
        }

        default: {
            return state;
        }
    }
}